/** @jsx jsx */
import { Global, jsx, css } from "@emotion/core";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Pressmark from "./Pressmark";



const transition = css`
  .translate-enter {
    opacity: 0;
    transform: translateX(-300px);
  }

  .translate-enter.translate-enter-active {
    opacity: 0.5;
    transform: translateX(0px);
    transition: all 200ms linear;
  }

  .translate-exit {
    opacity: 1;
    transform: translateX(0px);
  }

  .translate-exit.translate-exit-active {
    opacity: 0;
    transition: all 200ms linear;
    transform: translateX(-300px);
  }
`;

const PressmarkList = ({ pressmarks }) => {
  return (
    <div className="mt-4">
      <Global
        styles={transition}
 
      />
      <TransitionGroup>
      
        {pressmarks.map((item, index) => {
          return (
            <CSSTransition
              timeout={400}
              classNames="translate"
              key={`${index}${item}`}
            >
              <Pressmark key={index} {...item} />
            </CSSTransition>
          );
        })}
      </TransitionGroup>

      </div>
  );
};

export default PressmarkList;
